import UserAvatar from '../../User/UserAvatar'
import tracker from '../../../components/tracker/publish'
import Phrase from '../../../libs/translationsUtils/phrase'

const eventTracker = ({ url, title, type, idx, categoryId }) => {
  tracker.trackEvent('userevent', {
    type: 'Topic Clicked',
    topic_title: title,
    topic_url: url,
    topic_position: idx + 1, // to start index from 1 instead of 0, added +1
    topic_topic_type: type.toLowerCase() === 'discussion' ? 'conversation' : type.toLowerCase(),
    category_id: categoryId,
    click_source: 'knowledgebase'
  })
}

const ForumContentCurationItem = (props) => {
  const { url, title, icon, cdn, author, type, image } = props
  let src = ''

  if (image) {
    src = image.match(/^http/) ? image : cdn + image
  }

  return (
    <li class='topic-curation__item'>
      <a class='topic-curation__item-link link' href={url} onClick={() => eventTracker(props)} />
      <div class='topic-curation__item-icon'>
        {icon}
      </div>
      <div class='topic-curation__item-body'>
        <h4 class='topic-curation__title thread-list-block__title'>{title}</h4>
        <div class='topic-curation__item-type'>
          <span class='topic-curation__item-type-text'>
            <Phrase p={`knowledge.base.topic.metadata.${type}`} />
            <UserAvatar user={author} extraClass='avatar--XS' />
            <a class='topic-curation__item-type-link' href={author.url}>{author.name}</a>
          </span>
        </div>
      </div>
      {image ? <img class='topic-curation__item-image' src={src} alt='Topic image' /> : null}
    </li>
  )
}

export default ForumContentCurationItem
